import Marquee from "react-fast-marquee";

const ITEMS = [
  "Pronto intervento in giornata",
  "Diritto di chiamata 50€",
  "Caldaie",
  "Condizionatori",
  "Preventivi gratuiti",
  "Tecnici certificati",
  "Ricambi originali",
];

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="border-y border-white/10 bg-[#0A0D12] py-5 select-none"
  >
    <Marquee speed={20} gradient={false}>
      {ITEMS.map((item) => (
        <span
          key={item}
          className="font-mono-tech text-sm uppercase tracking-[0.25em] text-[#94A3B8] mx-12 flex items-center gap-12"
        >
          {item}
          <span className="text-[#FF6B00]">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
